module.exports = __webpack_public_path__ + "static/media/video.1f97c042.webm";